import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import CountdownTimer from "./CountdownTimer";
import "./Hero.css";

const Hero = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <section id="home" className="hero">
      <div
        className="hero-background"
        style={{ transform: `translateY(${scrollY * 0.5}px)` }}
      ></div>

      <motion.div
        className="hero-content"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.2 }}
      >
        <motion.div
          className="hero-shortcuts"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <a href="#rsvp" className="shortcut-card">
            <div className="shortcut-icon">💌</div>
            <h3>RSVP</h3>
            <p>Svar på om du kommer</p>
          </a>

          <a href="#schedule" className="shortcut-card">
            <div className="shortcut-icon">📅</div>
            <h3>Program</h3>
            <p>Se dagsplanen</p>
          </a>

          <a href="#locations" className="shortcut-card">
            <div className="shortcut-icon">📍</div>
            <h3>Lokasjoner</h3>
            <p>Finn veien</p>
          </a>

          <a href="#catering" className="shortcut-card">
            <div className="shortcut-icon">🍽️</div>
            <h3>Servering</h3>
            <p>Mat & drikke</p>
          </a>
        </motion.div>

        <motion.h1
          className="hero-title"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          Lars & Guro
        </motion.h1>

        <motion.p
          className="hero-subtitle"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          Gifter seg
        </motion.p>

        <motion.div
          className="hero-date"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
        >
          <p>Lørdag, 23. mai 2026</p>
          <p>Åsane gamle kirke</p>
        </motion.div>

        <motion.div
          className="hero-countdown"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1 }}
        >
          <CountdownTimer />
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
